import store from "../../../../store";
import east_export from './east_export.vue';

window.east_export =  new Vue({
    store,
    el: 'div#east_export',

    name : "east_export",
    data () {
        return {

        }
    },
    created () {

    },
    components : {
        east_export,
    }
});
